import * as Yup from 'yup'

const UpdateShipmentSchema = Yup.object().shape({
  tracking_number: Yup.string(),

  proof_of_shipping_image: Yup.mixed()
    .nullable()
    .test('fileSize', 'File size must be less than 5 MB', (value) => {
      if (!value) return true
      return value.size <= 5 * 1024 * 1024 // 5 MB
    })
})

export default UpdateShipmentSchema
